import React from 'react';
import { Menu, User } from 'lucide-react';
interface HeaderProps {
  onMenuClick: () => void;
  selectedMonth: 'current' | 'next';
  onMonthChange: (month: 'current' | 'next') => void;
}
export function Header({
  onMenuClick,
  selectedMonth,
  onMonthChange
}: HeaderProps) {
  return <header className="sticky top-0 z-30 flex h-16 w-full items-center justify-between border-b border-[#e5e5e5] bg-[#fafaf9] px-4 shadow-sm md:px-6" data-id="element-781">
      {/* Left: Mobile Menu & Title */}
      <div className="flex items-center gap-4" data-id="element-782">
        <button onClick={onMenuClick} className="text-[#062133] hover:text-[#ff697f] md:hidden min-h-[44px] min-w-[44px] flex items-center justify-center -ml-2" aria-label="Open menu" data-id="element-783">
          <Menu size={24} data-id="element-784" />
        </button>

        <div className="flex items-center text-lg md:text-xl" data-id="element-785">
          <img src="https://cdn.magicpatterns.com/uploads/jCJC46awojDwi4ekzzWFGE/jemx-logo.svg" alt="jemX" className="h-7 object-contain md:hidden mr-2" data-id="element-786" />
          <span className="font-bold text-[#062133]" data-id="element-787">jemX</span>
          <span className="mx-2 text-[#e5e5e5]" data-id="element-788">|</span>
          <span className="font-medium text-[#5a7280]" data-id="element-789">Roster Health</span>
        </div>
      </div>

      {/* Right: Controls & Profile */}
      <div className="flex items-center gap-4 md:gap-6" data-id="element-790">
        {/* Month Toggle */}
        <div className="hidden sm:flex items-center rounded-lg bg-white p-1 border border-[#e5e5e5]" data-id="element-791">
          <button onClick={() => onMonthChange('current')} className={`
              rounded-md px-3 py-1.5 text-sm font-medium transition-all min-h-[32px]
              ${selectedMonth === 'current' ? 'bg-[#062133] text-[#fff7ec] shadow-sm' : 'text-[#5a7280] hover:bg-gray-50'}
            `} data-id="element-792">
            Current Month
          </button>
          <button onClick={() => onMonthChange('next')} className={`
              rounded-md px-3 py-1.5 text-sm font-medium transition-all min-h-[32px]
              ${selectedMonth === 'next' ? 'bg-[#062133] text-[#fff7ec] shadow-sm' : 'text-[#5a7280] hover:bg-gray-50'}
            `} data-id="element-793">
            Next Month
          </button>
        </div>

        {/* Mobile Month Toggle (Simplified) */}
        <div className="sm:hidden" data-id="element-794">
          <select value={selectedMonth} onChange={e => onMonthChange(e.target.value as 'current' | 'next')} className="block w-full rounded-md border border-[#e5e5e5] bg-white py-1.5 pl-3 pr-8 text-sm text-[#062133] focus:border-[#062133] focus:outline-none focus:ring-1 focus:ring-[#062133] min-h-[44px]" data-id="element-795">
            <option value="current" data-id="element-796">Current Month</option>
            <option value="next" data-id="element-797">Next Month</option>
          </select>
        </div>

        {/* User Avatar */}
        <button className="flex h-9 w-9 items-center justify-center rounded-full bg-[#e5e5e5] text-[#062133] hover:ring-2 hover:ring-[#ff697f] transition-all min-h-[44px] min-w-[44px]" aria-label="User profile" data-id="element-798">
          <User size={20} data-id="element-799" />
        </button>
      </div>
    </header>;
}